module.exports = __webpack_public_path__ + "fr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/fr.svg
// module id = 552
// module chunks = 0